import React from 'react';
import calendar2 from './../../../assets/img/brand/pzu/calendar2.png';
import info from './../../../assets/img/brand/pzu/info.png';
import arrowRight from './../../../assets/img/brand/pzu/arrowRight.png';
import exclamationMark from './../../../assets/img/brand/pzu/exclamationMark.png';

const ZasadyPrzystepowania = () => {
  return (
    <React.Fragment>
      <h3 className="page-header firstColor">
        Jak przystąpić do ubezpieczenia zdrowotnego
      </h3>
      <br />
      <div className="secondColor">
        {/* <div className="container mb-4">
          <div className="row">
            <div className="col-sm-1 text-right">
              <img src={exclamationMark} alt="uwaga" />
            </div>
            <div className="col-sm">
              <b>Uwaga!</b> Jeżeli aktualnie jesteś objęty ubezpieczeniem{' '}
              <b>Opieka Medyczna w TUW PZUW</b>, wypełnij na nowo formularz
              przystąpienia. Jeśli nie wypełnisz formularza do{' '}
              <b>20 grudnia 2025 roku</b>, ochrona ubezpieczeniowa Twoja i
              członków Twojej rodziny zakończy się z dniem{' '}
              <b>31 grudnia 2025 roku</b>.
            </div>
          </div>
        </div> */}

        <p>
          Jeśli do tej pory nie korzystałeś z ubezpieczenia i chcesz do niego
          przystąpić,
          <b> zarejestruj się i wypełnij formularz online</b> dla siebie i
          swoich najbliższych.
        </p>

        <p>
          Oferta skierowana jest do:
          <ul>
            <li>obecnych współpracowników</li>
            <li>
              byłych pracowników w ciągu trzech miesięcy od daty ustania
              stosunku pracy
            </li>
          </ul>
        </p>

        <div className="container mt-4">
          <div className="row">
            <div className="col-sm-1 d-flex align-items-center">
              <img src={arrowRight} alt="arrow" />
            </div>
            <div className="col-sm">
              Wydrukuj i <b>podpisz dokumenty</b> wraz ze{' '}
              <b>wszystkimi zgłoszonymi członkami rodziny</b> (w przypadku
              niepełnoletniego dziecka deklarację podpisuje opiekun prawny).
            </div>
          </div>

          <div className="row">
            <div className="col-sm-1 d-flex align-items-center"></div>
            <div className="col-sm pl-0">
              <ul className="listArrowRight">
                <li className="mt-4">
                  Podpisaną deklarację prześlij w formie skanu lub zdjęcia na
                  adres mailowy{' '}
                  <a href="mailto:deklaracje@datus.pl" className="firstColor">
                    <b>deklaracje@datus.pl</b>
                  </a>{' '}
                  lub listownie na adres:
                  <br />
                  <br /> Datus Sp. z o.o.,
                  <br /> ul. Obrzeżna 7,
                  <br /> 02-691 Warszawa
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col-sm-1 d-flex align-items-center">
              <img src={calendar2} alt="calendar" />
            </div>
            <div className="col-sm">
              Aby zostać objętym ubezpieczeniem zdrowotnym od{' '}
              <b>1 dnia miesiąca</b>, wypełnij, opłać i prześlij deklarację do{' '}
              <b>
                20 dnia miesiąca poprzedzającego rozpoczęcie ochrony
                ubezpieczeniowej
              </b>
              , np. jeśli wypełnisz deklarację do <b>20 listopada</b> – opieka
              medyczna rozpocznie się od <b>1 grudnia</b>; jeśli wypełnisz
              formularz pomiędzy <b>21 listopada</b> a <b>20 grudnia</b> opieka
              medyczna rozpocznie się 1 stycznia.
            </div>
          </div>
          <div className="row">
            <div className="col-sm-1 d-flex align-items-center"></div>
            <div className="col-sm">
              <br />
              Pamiętaj, że składki za ubezpieczenie{' '}
              <b>opłacane są indywidualnie</b> na wskazany w deklaracji numer
              subkonta bankowego. Nieterminowe opłacenie składki będzie
              skutkowało zakończeniem ochrony.
            </div>
          </div>
        </div>

        <br />
        <span>
          Możesz również objąć ubezpieczeniem członków swojej rodziny,
          wybierając odpowiedni pakiet:
        </span>
        <ul className="mt-3">
          <li>
            <b>Pakiet Partnerski</b> – dla współpracownika i jednego członka
            rodziny (małżonka/partnera życiowego albo dziecka*)
          </li>
          <li>
            <b>Pakiet Rodzinny</b> – dla współpracownika i dwóch lub więcej
            członków rodziny (małżonka/partnera życiowego i/lub dzieci bez
            względu na ich liczbę*),
            <br />
            <small>
              *Dziecko własne lub przysposobione, pozostające na utrzymaniu
              współpracownika TVP, do ukończenia 26 roku życia.
            </small>
          </li>
          <li>
            <b>Dorosłe dziecko</b> – dla dorosłego dziecka współpracownika,
            które ukończyło 26 r.ż.
          </li>
          <li>
            <b>Senior</b> – dla rodziców i teściów współpracowników TVP, którzy
            nie ukończyli 80 r.ż.
          </li>
        </ul>

        <p className="mt-3">
          Deklarację przystąpienia do ubezpieczenia dla dorosłego dziecka i
          seniora złóż za pośrednictwem formularza on-line, wybierając
          odpowiednią sekcję <b>„Senior”</b> lub <b>„Dorosłe Dziecko”</b>. W
          tych sekcjach znajdziesz również informacje dotyczące zasad płatności
          za pakiety oraz terminów składania deklaracji.
        </p>

        <div className="container mt-4">
          <div className="row">
            <div className="col-sm-1 text-right">
              <img src={info} alt="info" />
            </div>
            <div className="col-sm">
              <b>Pamiętaj:</b> aby zgłosić do ubezpieczenia członków rodziny, w
              tym seniora lub dorosłe dziecko, musisz mieć aktywny pakiet opieki
              medycznej.
            </div>
          </div>
        </div>

        <br />
        <br />
        <span>
          <b className="firstColor">
            Możesz dokonać zmiany pakietu lub zakresu ubezpieczenia wypełniając
            nową deklarację przystąpienia
          </b>
        </span>
        <ul>
          <li>
            zmiana pakietu/zakresu z <b>„niższego na wyższy”</b> (np. z
            indywidualnego na pakiet partnerski lub rodzinny albo z zakresu
            Komfort Plus na Optimum) możliwa jest w <b>dowolnym momencie</b> z
            datą obowiązywania od 1 dnia kolejnego miesiąca,
          </li>
          <li>
            zmiana pakietu/zakresu z <b>„wyższego na niższy”</b> (np. z zakresu
            Optimum na Komfort Plus lub pakietu partnerskiego na indywidualny)
            możliwa jest w <b>rocznicę umowy</b> (tj. 1 stycznia 2027 roku).
          </li>
        </ul>

        <p>
          Zmiany wymagają złożenia nowej deklaracji do{' '}
          <b>20 dnia miesiąca poprzedzającego</b> ich wejście w życie. Po
          złożeniu nowej deklaracji pamiętaj o przesłaniu skanu na adres{' '}
          <a href="mailto:deklaracje@uspartner.pl" className="firstColor">
            <b>deklaracje@uspartner.pl</b>
          </a>
          .
        </p>

        <b className="firstColor">Rezygnacja z ubezpieczenia</b>
        <p>
          W celu rezygnacji z ubezpieczenia, po zalogowaniu się na swoje konto,
          należy w sekcji <b>Moje wnioski</b> zaznaczyć w aktywnym wniosku opcję{' '}
          <b>Zrezygnuj</b>.
        </p>
        <p>
          Nieopłacenie składki w terminie będzie skutkowało zakończeniem
          ubezpieczenia.
        </p>
        <p>
          <b>
            Ponowne przystąpienie do ubezpieczenia możliwe jest wyłącznie w
            rocznicę umowy, tj. 01.01.2027 r.
          </b>
        </p>
      </div>
    </React.Fragment>
  );
};

export default ZasadyPrzystepowania;
